import React, { useState } from 'react';
import { BanWorkerModal } from 'parent-portal/shared/UserActions/WorkerLocationModal';
import { Modal, PillButton, Row, Stack, Text } from 'library/ui';
import { useUserContext } from 'UserContext';

import type { ShiftProviderUser } from 'models';

export default function BanProviderAction({
    open,
    onClose,
    provider,
}: {
    open: boolean;
    onClose: () => void;
    provider: ShiftProviderUser;
}) {
    const { user } = useUserContext();
    const [banAction, setBanAction] = useState(false);
    const businessId = user?.businesses_active?.[0]?.id;

    if (!businessId) return null;

    return (
        <>
            {open && (
                <Modal title={`${provider.first_name} has been removed from this shift.`} onClose={onClose}>
                    <Stack gap="lg">
                        <Text>
                            {provider?.first_name} has been successfully removed from the shift. If you would like to
                            request that they no longer be booked at this location or your entire business. Please
                            select the button below.
                        </Text>
                        <Row justify="end" fullWidth>
                            <PillButton variant="secondary" onClick={() => setBanAction(true)}>
                                Request Not To Book
                            </PillButton>
                            <PillButton
                                onClick={() => {
                                    setBanAction(false);
                                    onClose();
                                }}
                            >
                                Continue
                            </PillButton>
                        </Row>
                    </Stack>
                </Modal>
            )}
            <BanWorkerModal
                open={banAction}
                onSuccess={() => {}}
                onClose={() => setBanAction(false)}
                provider={provider}
            />
        </>
    );
}
